import { render } from "./InitialAssessment.vue?vue&type=template&id=05c1523a&scoped=true"
import script from "./InitialAssessment.vue?vue&type=script&lang=js"
export * from "./InitialAssessment.vue?vue&type=script&lang=js"

import "./InitialAssessment.vue?vue&type=style&index=0&id=05c1523a&scoped=true&lang=css"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c1523a"]])

export default __exports__